import { Component, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { Router } from "@angular/router";
import { User } from '../../models/user/user-model';
import { UserService } from '../../services/user/user.service';
import { RoleService } from '../../services/role/role.service';
import { StateService } from '../../services/state/state.service';
import { CountryService } from '../../services/country/country.service';
import { Role } from '../../models/shared/role.model';
import { Country } from '../../models/country/country-model';
import { State } from '../../models/state/state-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.css']
})
/** user-create component*/
export class UserCreateComponent {
  /** user-create ctor */
  userModel = new User();
  roleList : Role[] = [];
  isUnique = true;
  isPasswordMatch = true;
  isSubmitted = false;
  countryList: Country[] = [];
  stateList: State[] = [];
  maxDate: Date;
  constructor(private readonly userService: UserService,
    private readonly roleService: RoleService,
    private readonly countryService: CountryService,
    private readonly stateService: StateService,
    public toastr: ToastsManager,
    private readonly rolePermissionService: RolePermissionService,
    private readonly router: Router,
    vcr: ViewContainerRef)
  {

    this.rolePermissionService.GetRolePermissions("user").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.maxDate = new Date();
            this.maxDate.setDate(this.maxDate.getDate());
            this.userModel.roleID = "";
            this.userModel.countryID = "";
            this.userModel.stateID = "";
            this.toastr.setRootViewContainerRef(vcr);
            this.GetRoles();
            this.GetCountries();
          }
          else {
            this.router.navigate(["/users"]);
          }
        }
        else {
          this.router.navigate(["/users"]);
        }
      }
    )
  }

  IsUniqueEmail() {
    this.userService.isUniqueEmail(this.userModel.email).subscribe(
      data => {
        if (data) {
          this.isUnique = true;
        }
        else {
          this.isUnique = false;
        }
      });
  }

  GetRoles() {
    this.roleService.GetActiveRoles().subscribe(
      data => {
        this.roleList = data;
      });
  }

  KeyPressEvenet() {
    this.isUnique = true;
  }

  GetCountries() {
    this.countryService.getCountries().subscribe(
      data => {
        this.countryList = data;
      });
  }

  GetStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.stateList = data;
      });
  }

  ngSubmit() {
    if (this.isPasswordMatch) {
      if (this.isUnique) {
        this.isSubmitted = true;
        this.userService.addUser(this.userModel).subscribe(
          data => {
            if (data) {
              this.toastr.success('User has been saved', 'Success');
              setTimeout(() => {
                this.router.navigate(["/users"]);
              }, 2000);
            }
            else {
              this.toastr.error('Error occurred. Please try again', 'Error');
              this.isSubmitted = false;
            }
          });
      }
    }
  }
  checkPasswords() {
    if (this.userModel.confirmPassword != this.userModel.password)
      this.isPasswordMatch = false;
    else
      this.isPasswordMatch = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/user-components/user-create/user-create.component.ts